import axios from 'axios';
import {backendHost} from '../../config';

export const getPaymentsById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/finance-operation/${params.id}`);
};